// extracted by mini-css-extract-plugin
module.exports = {"tagBtn":"TagViewer_tagBtn__1AdPA","tagContainer":"TagViewer_tagContainer__35co3"};